export const PARAMETERIZATION_SYSTEM_USER_MESSAGE_PREFIXES = [
  'PARAMETRIZACAO_INICIAR',
  'PARAMETRIZACAO_COMPLETA:',
];

export function isParameterizationSystemUserMessage(text) {
  if (!text || typeof text !== 'string') {
    return false;
  }

  const normalized = text.trim();
  return PARAMETERIZATION_SYSTEM_USER_MESSAGE_PREFIXES.some((prefix) =>
    normalized.startsWith(prefix),
  );
}

export function buildParameterizationCompletionMessage(step) {
  return `PARAMETRIZACAO_COMPLETA: ${step}`;
}
